// only run on instruments page
Clean_Duplicate_Items("cc-rich-text")
function Clean_Duplicate_Items(selector_class){
    for (elem of document.querySelectorAll(`.shopify-section.${selector_class}`)){
      let next_section = elem.nextSibling
      while (next_section != null && next_section.offsetHeight < 1){
        next_section = next_section.nextSibling
      }
    if (next_section.nextSibling != null && next_section.classList.contains(selector_class) ){
      elem.remove()
    }
  }
}
